import React from 'react';
import Storage from 'dashboards/Storage';
//import RecentClients from 'dashboards/RecentClients';
import RecentReports from 'dashboards/RecentReports';
import RecentCharts from 'dashboards/RecentCharts';
import RecentPatients from 'dashboards/RecentPatients';
import homeSx from './Home.styles';
import { useTheme } from '@mui/material/styles';
import Announcement from 'components/Announcement';
import { Box, Typography } from '@mui/material';



const Home = () => {
	const theme = useTheme();
	const sx = homeSx(theme);
	return (
		<div>
			<Box sx={sx.flexContainer}>
				<Announcement
					variant="blueGrey"
					size="xl"
					headerContent={
						<Typography variant="h6" color="inherit" align="left">Welcome!</Typography>
					}
				>
					<Typography gutterBottom>
						Hi there!
					</Typography>
				</Announcement>


				<RecentCharts />

				<RecentPatients />

				<RecentReports />

				<Storage />
			</Box>
		</div>
	);
};



export default Home;
